import './IncidentOverview.scss'

import AutomaticHandlingRecommendations from './automaticHandling/AutomaticHandlingRecommendations'

import ManualHandlingIncidentTypes from './manualHandling/manualHandlingIncidentTypes/ManualHandlingIncidentTypes'
import ManualHandlingShortcuts from './manualHandling/manualHandlingShortcuts/ManualHandlingShortcuts'
import ManualHandlingTextSearch from './manualHandling/manualHandlingTextSearch/ManualHandlingTextSearch'
import IncidentCollectionRequestType from './../../common/types/IncidentCollectionRequestType'
import IncidentActionRequestType from './../../common/types/IncidentActionRequestType'
import IIncidentOverview from '../../common/interfaces/incidentOverview/IIncidentOverview'
import StatusDetailedAnalysisComparisonBars from './status/statusDetailedAnalysis/statusDetailedAnalysisComparisonBars/StatusDetailedAnalysisComparisonBars'
import IEntityIncident from '../../common/interfaces/entityIncident/IEntityIncident'
import UserGuide from './userGuide/UserGuide'
import StatusSupervisionHighLevel from './status/statusDetailedAnalysis/statusSupervision/StatusSupervisionHighLevel'
import ICustomer from '../../common/interfaces/customer/ICustomer'
import IApplicationSettings from '../../common/interfaces/applicationSettings/IApplicationSettings'

type ComponentProps = {
  customer: ICustomer
  domain: string
  activeUserGuideTopicName: null|undefined|string
  handleActiveUserGuideTopicNameChangeRequest: (request:string) => void
  incidentDecisionMakerClueFilter: null|undefined|string
  incidentOverview: null|undefined|IIncidentOverview
  settingsMinimizeOverviewWhenRequestingCollection: boolean
  handleIncidentCollectionChangeRequest: (request:IncidentCollectionRequestType) => void
  handleIncidentActionChangeRequest: (request:IncidentActionRequestType) => void
  handleEntityIncidentsToRemoveChange:(entityIncidents:IEntityIncident[]) => void
  handleIncidentOverviewRequest: () => void
  incidentCollectionCloseRequest: string
  applicationSettings: null|undefined|IApplicationSettings
}

const IncidentOverview = (props:ComponentProps) => {

  return (
    <div id='overview-sections'>

      <UserGuide 
          incidentOverview={props.incidentOverview}
          domain={props.domain}
          activeUserGuideTopicName={props.activeUserGuideTopicName}
          handleActiveUserGuideTopicNameChangeRequest={props.handleActiveUserGuideTopicNameChangeRequest}
          customer={props.customer}
      />      

      <ManualHandlingIncidentTypes 
        domain={props.domain}
        incidentOverview={props.incidentOverview}
        handleIncidentCollectionChangeRequest={props.handleIncidentCollectionChangeRequest}
        handleActiveUserGuideTopicNameChangeRequest={props.handleActiveUserGuideTopicNameChangeRequest}
      />

      <ManualHandlingTextSearch 
        handleActiveUserGuideTopicNameChangeRequest={props.handleActiveUserGuideTopicNameChangeRequest}
        incidentOverview={props.incidentOverview}
        handleIncidentCollectionChangeRequest={props.handleIncidentCollectionChangeRequest} 
        incidentCollectionCloseRequest={props.incidentCollectionCloseRequest} />

      <ManualHandlingShortcuts 
        handleActiveUserGuideTopicNameChangeRequest={props.handleActiveUserGuideTopicNameChangeRequest}
        incidentOverview={props.incidentOverview}
        handleIncidentCollectionChangeRequest={props.handleIncidentCollectionChangeRequest}
        applicationSettings={props.applicationSettings} />

      {
        props.incidentOverview?.status?.detailedAnalysis?.userIncidentScores &&
        <StatusDetailedAnalysisComparisonBars 
          customer={props.customer}           
          handleActiveUserGuideTopicNameChangeRequest={props.handleActiveUserGuideTopicNameChangeRequest}
          incidentOverview={props.incidentOverview} />
      }

      <AutomaticHandlingRecommendations
        customer={props.customer}
        domain={props.domain}
        handleActiveUserGuideTopicNameChangeRequest={props.handleActiveUserGuideTopicNameChangeRequest}
        incidentDecisionMakerClueFilter={props.incidentDecisionMakerClueFilter}
        incidentOverview={props.incidentOverview}
        handleIncidentCollectionChangeRequest={props.handleIncidentCollectionChangeRequest} 
        handleIncidentActionChangeRequest={props.handleIncidentActionChangeRequest} 
        handleEntityIncidentsToRemoveChange={props.handleEntityIncidentsToRemoveChange} />
      
      {
        (
          (props.incidentOverview?.status.detailedAnalysis.supervision?.highestIncidentCount.length ?? 0) +
          (props.incidentOverview?.status.detailedAnalysis.supervision?.highestCancellationCount.length ?? 0)
        ) > 0 &&
        <StatusSupervisionHighLevel 
          handleActiveUserGuideTopicNameChangeRequest={props.handleActiveUserGuideTopicNameChangeRequest}
          incidentOverview={props.incidentOverview} />
      }    
    </div>
  )
}

export default IncidentOverview